import { ExternalIntegration } from 'dashboard/models/external-integration';
import Action from 'lib/interfaces/Action';

export type ExternalIntegrationActions =
  | Action<ExternalIntegrationsActionType.ClearExternalIntegrations>
  | Action<ExternalIntegrationsActionType.SetExternalIntegration, SetExternalIntegrationPayload>
  | Action<ExternalIntegrationsActionType.SetExternalIntegrations, SetExternalIntegrationsPayload>;

export enum ExternalIntegrationsActionType {
  SetExternalIntegration = 'external-integrations/SET_EXTERNAL_INTEGRATION',
  SetExternalIntegrations = 'external-integrations/SET_EXTERNAL_INTEGRATIONS',
  ClearExternalIntegrations = 'external-integrations/CLEAR_EXTERNAL_INTEGRATIONS',
}

export interface SetExternalIntegrationPayload {
  externalIntegration: ExternalIntegration;
}

export interface SetExternalIntegrationsPayload {
  externalIntegrations: ExternalIntegration[];
  merge: boolean;
}

export function clearExternalIntegrations(): Action<ExternalIntegrationsActionType.ClearExternalIntegrations> {
  return { type: ExternalIntegrationsActionType.ClearExternalIntegrations };
}

export function setExternalIntegration(
  externalIntegration: ExternalIntegration,
): Action<ExternalIntegrationsActionType.SetExternalIntegration, SetExternalIntegrationPayload> {
  return {
    payload: {
      externalIntegration,
    },
    type: ExternalIntegrationsActionType.SetExternalIntegration,
  };
}

export function setExternalIntegrations(
  externalIntegrations: ExternalIntegration[],
  merge = false,
): Action<ExternalIntegrationsActionType.SetExternalIntegrations, SetExternalIntegrationsPayload> {
  return {
    payload: {
      externalIntegrations,
      merge,
    },
    type: ExternalIntegrationsActionType.SetExternalIntegrations,
  };
}
